<template>
    <v-navigation-drawer
      fixed app v-model="drawer" :clipped="clipped" enable-resize-watcher
      height="100%" right color="secondary" temporary class=""
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title @click="changePage(`/admin/promoterDashboard`)">
              <!--:href="`${root}/admin/promoterDashboard`" target="_blank"-->
              <a
                class="legacy-dashboard"
                rel="noopener noreferrer"
                >{{ $t("top-menu.all.legacy-dashboard") }}</a
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list>
        <template v-for="(item, index) in topMenu">
          <v-list-group v-if="item.items && item.items.length > 0" :key="index + '-p'">
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(subitem, i) in item.items"
              :key="i"
              link
            >
              <v-list-item-icon v-if="subitem.icon" style="margin: auto 1rem">
                <v-icon>{{ subitem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title @click="changePage('', subitem.name)">{{$t(subitem.lang)}}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="index + '-s'" link>
            <v-list-item-icon v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title @click="changePage(item.href, item.name, item.legacy)" :style="{ textAlign: item.icon ? 'left' : 'center' }" >
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>    
</template>

<script>

export default {
    props: ['topMenu','drawerRight'],
    data() {
        return {
            clipped: false
        };
    },
    computed: {
        root: () => process.env.VUE_APP_ROOT,
        buttonsRaceEdit() {
            return [
                {
                    title: this.$t("top-menu.all.dashboard"),
                    icon: "far fa-tachometer",
                    name: "PromoterDashboard",
                },
                {
                    title: this.$t("top-menu.raceEdit.participants"),
                    icon: "far fa-clipboard",
                    name: false,
                    items: [
                        {
                            indexTitle: "top-menu.raceEdit.participantsItems.newParticipant",
                            icon: "far fa-user-plus",
                            name: "NewParticipant"
                        },
                        {
                            indexTitle: "top-menu.raceEdit.participantsItems.participant-scores",
                            icon: "far fa-clock",
                            name: "ParticipantScores"
                        },
                        {
                            indexTitle: "top-menu.raceEdit.participantsItems.deleteClass",
                            icon: "far fa-trash",
                            name: "DeleteClassScore"
                        },
                    ]
                },
                {
                    title: this.$t("top-menu.raceEdit.scores"),
                    icon: "far fa-clock",
                    name: false,
                    items: [
                        {
                            indexTitle: "top-menu.raceEdit.scoresItems.quickScore",
                            icon: "far fa-fire",
                            name: "QuickScore"
                        },
                        {
                            indexTitle: "top-menu.raceEdit.scoresItems.addDnf",
                            icon: "far fa-users",
                            name: "AddDNFParticipants"
                        },
                        {
                            indexTitle: "top-menu.raceEdit.scoresItems.clearScores",
                            icon: "far fa-times-circle",
                            name: "ClearAllScores"
                        },
                        {
                            indexTitle: "top-menu.raceEdit.scoresItems.importScore",
                            icon: "far fa-downlraceDetailsoad",
                            name: "ImportScoresFromRace"
                        },
                    ]
                },
                {
                    title: this.$t("top-menu.raceEdit.back"),
                    icon: "far fa-tags",
                    name: "raceDetails",
                },
            ];
        },
        buttonsReports() {
            return  [
                {
                    title: this.$t("top-menu.all.dashboard"),
                    icon: "far fa-tachometer",
                    name: "dashBoard",
                },
                {
                    title: this.$t("top-menu.all.series"),
                    icon: "far fa-tachometer",
                    name: "seriesDashboard",
                },
            ];
        },
        buttonsSeries() {
            return [
                {
                title: this.$t("top-menu.all.dashboard"),
                icon: "far fa-tachometer",
                name: "dashBoard",
                },
                {
                title: this.$t("top-menu.all.reports"),
                icon: "far fa-tachometer",
                name: "reportsDashboard",
                },
            ];
        },
        drawer: {
          get() {
            return this.drawerRight;
          },
          set(value) {
            this.$emit('changeDrawerRight',value);
          }
        },
        sectionsUpdated() {
          return this.$store.getters.getSectionsUpdate;
        },
        isChangesSections() {
          return (
            (this.$route.name == 'SectionEditor' || this.$route.name == 'SectionEditorOld') && 
            this.sectionsUpdated.length > 0
          );
        },
    },
    methods: {
      isUrlVue(url) {
        return url.includes('/promoter/#/');
      },
      changePage(page, name = '', legacy = false) {
        if(name && name != '' && !legacy) {
          this.$router.push({
            name, params: this.$route.params
          });
        }
        var path = "";

        if(legacy) {
          if(name == "PromoterDashboard"){
            path = page;
            window.location.href = `${process.env.VUE_APP_ROOT}${path}`;
          }
        }else if (page == "dashBoard") {
          path = `/dashBoard`;
          this.isComponents = "promoter_dashboard";
        } else if (page == "registration")
          path = `/registration/eventId/${this.$route.params.id}`;
        else if (page == "wait_list") path = `/waitList/eventId/${this.$route.params.id}`;
        else if (page == "classes") path = `/classes/eventId/${this.$route.params.id}`;
        else if (page == "brands") path = `/Brands/eventId/${this.$route.params.id}`;
        else if (page == "teams") path = `/teams/eventId/${this.$route.params.id}`;
        else if (page == "start_grids")
          path = `/startGrids/eventId/${this.$route.params.id}`;
        else if (page == "clone_events")
          path = `/cloneEvents/eventId/${this.$route.params.id}`;
        else if (page == "seriesDashboard") {
          path = `/seriesDashboard`;
          this.isComponents = "serie";
        } else if (page == "reportsDashboard") {
          path = `/reportsDashboard`;
          this.isComponents = "reports";
        } else if (page == "results-editor") path = `/raceEdit/${this.$route.params.id}`;
        else if (page == "enduro-section-editor")
          path = `/enduroSectionEditor/raceId/${this.$route.params.id}`;
        else if (page == "section-editor")
          path = `/events/races/section-editor/${this.$route.params.id}`;
        else if (page == "phone-monitor")
          path = `/phoneMonitor/raceId/${this.$route.params.id}`;
        else if (page == "duplicate-race")
          path = `/dashBoard/raceDetails/${this.$route.params.id}`;
        else if (name == this.$route.name){
          window.location.reload();
        }

        if (this.$route.path !== path && path != "") {
          this.$router.push({
            path: path,
          });
        } else if(page != "") {
          let url = `${process.env.VUE_APP_ROOT}${page}`;
          if(this.isChangesSections && !this.isUrlVue(url)) {
            this.$store.commit('setNextUrl',url);
            this.$store.commit('setActiveMessageConfirmation', true);
          } else {
            window.location.href = url;
          }
        }
      },
    }
};
</script>
